import { zEmployeeCommonSchema } from "./employee.common";
export const zEmployeeSchemaDto = zEmployeeCommonSchema;
export const zEmployeeSchemaCreateDto = zEmployeeSchemaDto.omit({ id: true });
